// Utility to ensure URLs are absolute with protocol
// Adds https:// if no scheme is present and the string looks like a domain
export function toAbsoluteUrl(input) {
  if (!input || typeof input !== 'string') return '';
  const url = input.trim();
  if (!url) return '';
  // If already starts with a scheme, return as-is
  if (/^https?:\/\//i.test(url)) return url;
  // If it looks like an email, don't change it
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(url)) return url;
  // Prepend https:// for domains or bare hosts
  return `https://${url}`;
}
